export default __webpack_public_path__ + "navigation-examples-styled-ui-elements-thumbnail-v1-960-7d3f64320a7458efcce6f5a428c736ab.png";